import { render } from "./Option.vue?vue&type=template&id=ee34e8d8&scoped=true&ts=true"
import script from "./Option.vue?vue&type=script&lang=ts"
export * from "./Option.vue?vue&type=script&lang=ts"

import "./Option.vue?vue&type=style&index=0&id=ee34e8d8&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee34e8d8"]])

export default __exports__